module.exports = __webpack_public_path__ + "img/naturalbeige.1c5703c.jpg";